const replaceDoubleCurlyBracketsToICU = (obj, newObj) => {
  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (typeof obj[property] == "object") {
        newObj[property] = obj[property]
        replaceDoubleCurlyBracketsToICU(obj[property], newObj[property])
      } else if (typeof obj[property] === "string") {
        let value = obj[property] || ""
        value = value.replaceAll(/{{/g, "{").replaceAll(/}}/g, "}")
        newObj[property] = value
      } else {
        newObj[property] = obj[property]
      }
    }
  }
}

export const transformI18nNextFormatToICU = (obj) => {
  try {
    const newObj = {}
    replaceDoubleCurlyBracketsToICU(obj, newObj)
    return newObj
  } catch (e) {
    console.log(e)
  }
  return obj
}
